import AppRouter from "@/Routers/AppRouter";
import SessionRouter from "@/Routers/SessionRouter";

const routers = { SessionRouter, AppRouter };

export default routers;
